<template>
  <button
    type="button"
    :class="
      variant === 'pill'
        ? 'relative flex flex-none items-center gap-1.5 rounded-(--ds-radius-pill) px-[15px] py-2 text-[13.5px] font-semibold whitespace-nowrap text-(--ds-text-brand) shadow-[inset_0_0_0_1px_var(--ds-border-brand)] transition-colors duration-150 hover:bg-(--ds-surface-brand) focus-visible:outline-2 focus-visible:outline-focus'
        : 'relative flex min-h-11 w-full items-center gap-2.5 rounded-(--ds-radius-md) bg-(--ds-surface-default) px-2.5 text-left text-[14px] font-medium text-(--ds-text-brand) shadow-[inset_0_0_0_1px_var(--ds-border-brand)] transition-colors duration-150 hover:bg-(--ds-surface-brand) focus-visible:outline-2 focus-visible:outline-focus'
    "
    aria-haspopup="dialog"
    data-test="planner-video-open"
    @click="openPlannerVideo"
  >
    <!-- eslint-disable vue/no-v-html -- a static design-system icon -->
    <span
      :class="
        variant === 'pill'
          ? 'flex size-4 flex-none items-center justify-center rounded-full bg-(--ds-action-brand) text-(--ds-color-white) [&>svg]:size-2.5'
          : 'flex size-[26px] flex-none items-center justify-center rounded-(--ds-radius-sm) bg-(--ds-action-brand) text-(--ds-color-white) [&>svg]:size-4'
      "
      aria-hidden="true"
      v-html="ICONS.play"
    />
    <!-- eslint-enable vue/no-v-html -->
    <span
      class="leading-snug"
      :class="variant === 'pill' ? '' : 'py-2'"
      v-text="$t('planner.how_it_works.nav')"
    />
    <span
      class="ml-auto flex-none text-xs font-medium tabular-nums opacity-80"
      v-text="plannerVideoDuration"
    />
    <span
      v-if="dot"
      class="absolute top-1.5 right-1.5 size-2 rounded-full bg-primary ring-2 ring-white"
      aria-hidden="true"
      data-test="planner-video-dot"
    />
    <span v-if="dot" class="sr-only" v-text="$t('planner.help.new')" />
  </button>
</template>

<script setup>
/**
 * „So funktioniert's“ (Arnold, 02.11.2026, UX1): the one navigation entry that opens a dialog
 * instead of a page — a violet play chip and the duration set it apart from the page rows.
 * `column` sits below Reporting in the section column (from lg), `pill` ends the pill row below
 * lg. A brand dot marks it on the first visit (UX2), named „neu“ for screen readers.
 */
import { ICONS } from '@/Libraries/design-system-icons'
import {
  openPlannerVideo,
  plannerVideoDuration,
  usePlannerVideoDot,
} from '@/composables/plannerVideo'

defineProps({
  /** `column` (section column from lg) or `pill` (pill row below lg). */
  variant: { type: String, default: 'column' },
})

const dot = usePlannerVideoDot()
</script>
